
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M6.53485 7.62547C7.81934 6.02312 9.78984 5 12 5C15.2603 5 18.0024 7.2299 18.7795 10.2493C18.9232 10.8078 19 11.3942 19 12H16L20 16L24 12H21C21 11.2246 20.9017 10.4707 20.7164 9.75074C19.7173 5.86919 16.195 3 12 3C9.15734 3 6.6221 4.31903 4.97435 6.37453L6.53485 7.62547Z"></path><path d="M17.4651 16.3745C16.1806 17.9769 14.2101 19 12 19C8.73966 19 5.99761 16.7701 5.22048 13.7507C5.07673 13.1922 5 12.6058 5 12H8L4 8L0 12H3C3 12.7754 3.09829 13.5293 3.2836 14.2493C4.28264 18.1308 7.80499 21 12 21C14.8426 21 17.3779 19.681 19.0256 17.6255L17.4651 16.3745Z"></path><path d="M8.5 15.2308C8.5 15.2308 9.66667 12.7024 12.2917 12.7024V14.388L15.5 11.5787L12.2917 8.76929V10.4549C9.08333 10.4549 8.5 13.2643 8.5 14.388V15.2308Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowloopskipFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
